module.exports = __webpack_public_path__ + "static/media/Gible_gaussian2.c408032b.png";